// @flow
import _ from 'lodash';
import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import type { TPlayersById, TPlayer } from "../types";
import type { TSquadsById } from "../types";

const matchSelector = (state, props) => state.rounds.matches_by_id[props.match.params.match_id];
const playersSelector = (state): TPlayersById => state.players.by_id;
const squadsSelectors = (state): TSquadsById => state.squads.by_id;

export default createSelector(
	matchSelector,
	playersSelector,
	squadsSelectors,
	(match: Object, players: TPlayersById, squads: TSquadsById) => {

		// check if objs are ready
		if (match === undefined ||
			isEmpty(match) ||
			isEmpty(players)) {
			return { players: [] };
		}

		const playersArr: Array<TPlayer> = _.values(players);

		// get list of home team players
		const home_team_players = playersArr.filter(
			(player: TPlayer) => player.squad_id === match.home_squad_id);

		const away_team_players = playersArr.filter(
			(player: TPlayer) => player.squad_id === match.away_squad_id
		);

		const all_players = [...home_team_players, ...away_team_players];

		return {
			match,
			players: all_players.map(player => ({ ...player, squad: squads[player.squad_id] }))
		};
	});


// WEBPACK FOOTER //
// ./src/modules/selectors/getMatchData.js